import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'customDateFormat',
})
export class CustomDateFormatPipe implements PipeTransform {

  constructor() { }

  transform(value: string, alwaysIncludeTime: boolean) {
    const m = moment(value);
    const today = moment(new Date().toISOString());
    let alwaysIncludeTimeExtension = '';

    if (alwaysIncludeTime) {
      alwaysIncludeTimeExtension = ' h:mm a';
    }

    if (m.toDate().getFullYear() < today.toDate().getFullYear()) { return m.format(`M/D/YYYY${alwaysIncludeTimeExtension}`); }
    if (m.toDate().getFullYear() === today.toDate().getFullYear() && m.toDate().getMonth() === today.toDate().getMonth()
      && m.toDate().getDate() === today.toDate().getDate()) { return m.format('h:mm a'); }

    return m.format(`MMM D${alwaysIncludeTimeExtension}`);
  }
}
